import * as components from './components'
import * as hooks from './hooks'
import * as types from './types'

console.log('Pages feature initialized!')

export { components, hooks, types }
